'use strict'

import { join, normalize, resolve } from 'path'
import _ from 'lodash'
import fs from 'fs-extra'
import pify from 'pify'
const glob = pify(require('glob'))

class VFs {

  constructor (options) {
    this.dir = (typeof options.rootDir === 'string' && options.rootDir ? options.rootDir : process.cwd())
    this.srcDir = (typeof options.srcDir === 'string' && options.srcDir ? resolve(this.dir, options.srcDir) : this.dir)
    this.commonsDir = (typeof options.commonsDir === 'string' && options.commonsDir ? resolve(this.dir, options.commonsDir) : null)
  }

  existsSync (path, srcOnly, commonsOnly) {
    let _path = _.isArray(path) ? normalize(_.join(path, '/')) : path
    if (srcOnly !== false && fs.existsSync(join(this.srcDir, _path))) return true
    if (commonsOnly !== false && this.commonsDir && fs.existsSync(join(this.commonsDir, _path))) return true
    return false
  }

  findSrc (path) {
    let _path = _.isArray(path) ? normalize(_.join(path, '/')) : path
    if (fs.existsSync(join(this.srcDir, _path))) return this.srcDir
    if (this.commonsDir && fs.existsSync(join(this.commonsDir, _path))) return this.commonsDir
    return null
  }

  each (resource, callback) {
    callback(resolve(this.srcDir, resource))
    if (this.commonsDir) callback(resolve(this.commonsDir, resource))
  }

  eachSrc (callback) {
    callback(this.srcDir)
    if (this.commonsDir) callback(this.commonsDir)
  }

  * glob (path) {
    let f1 = yield glob(path, {cwd: this.srcDir})
    let f2 = (this.commonsDir) ? yield glob(path, {cwd: this.commonsDir}) : []
    return _.concat(f1, f2)
  }
}

export default function (options) {
  return new VFs(options)
}



// WEBPACK FOOTER //
// ./lib/vfs.js